// Máscara para campos do tipo numérico sem casas decimais
angular.module("avlib").directive("avIntegerMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var groupDigits = function(value){
				if (value == null || value == ""){
					return value;
				}else{
					if (value.length > 3){
						var currentGroup = value.substr(value.length-3);
						var nextInput = value.substr(0, value.length-3);
						return groupDigits(nextInput) + "." + currentGroup;
					}else{
						return value;
					}
				}
			};

			var formatNumber = function(value){
				if (value === null || value == ""){
					return "";
				}

				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				// Removendo zeros em excesso, do lado esquerdo do número.
				var nonZeroIndex = value.search(/[1-9]/g);
				value = value.substr(nonZeroIndex, value.length-nonZeroIndex);

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
				value = groupDigits(value.substr(0,value.length));

				return value;
			};

			var numericParser = function(viewValue){
				if (viewValue == ""){
					ctrl.$setViewValue("");
					ctrl.$render();
					return null;
				}

				var formattedValue = formatNumber(viewValue);
				var modelValue = formattedValue.replace(/[^\d]/g,'');
				modelValue = modelValue.replace(/,/g,'.');
				modelValue = parseInt(modelValue);

				ctrl.$setViewValue(formattedValue);
				ctrl.$render();

				return modelValue;
			};

			var numericFormatter = function(modelValue){
				if (modelValue === null){
					return "";
				}else{
					if (isNaN(modelValue)){
						ctrl.$modelValue = null;
						return "";
					}else{
						ctrl.$modelValue = modelValue;
						return formatNumber(modelValue.toFixed(0));
					}
				}
			};

			ctrl.$parsers.push(numericParser);
			ctrl.$formatters.push(numericFormatter);
		}
	};
});
